import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import useInterviewStorePools from '../useInterviewStorePools';
import FormHelper from '../../../../../helpers/FormHelper';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();

  const {
    form,
    shoppingCenters,
    companyCategories,
    setTypeInterview,
    typeInterview,
    handleCreateOrUpdateCategory,
    updateInProcess,
  } = useInterviewStorePools(false, !isNew);

  const onFinish = async (values) => {
    await handleCreateOrUpdateCategory(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew ? t('Crea Sondaggio') : t('Modifica Sondaggio');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title: '',
            date_from: '',
            date_to: '',
            type_interview: '',
            shopping_center_id: '',
            company_category_answer_ids: [],
            company_category_question_ids: [],
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={(field) => {
            FormHelper.resetFormsFieldErrors(form)(field);
            if (field[0] && field[0].name[0] === 'type_interview') {
              setTypeInterview(field[0].value);
            }
          }}
        >
          <InfoSection
            companyCategories={companyCategories}
            shoppingCenters={shoppingCenters}
            typeInterview={typeInterview}
          />
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Edit;
